export default __webpack_public_path__ + "static/automateText-415bd0a344e204204a0e8644e138c8f8.png";